// Reserve-doppen in de cart drawer (winnaar A/B-test #22).
// Markup en afnameregel: snippets/cart-reserve-doppen.liquid.
//
// Doet drie dingen:
//   1. stepper (− / +) in stappen van de afnameregel, nooit onder het minimum;
//   2. meeprijs live meerekenen (aantal × stukprijs, in het geldformaat van de winkel);
//   3. na "Toevoegen" het blok voor de rest van de sessie verbergen (sessionStorage
//      per variant). De drawer wordt na elke cart-wijziging opnieuw gerenderd en
//      gemorpht; morph zet het `hidden`-attribuut dan terug, daarom wordt het
//      attribuut geobserveerd en meteen opnieuw gezet.
import { formatCurrency } from "@theme/utilities";

const STORAGE_PREFIX = "reserve-doppen-";

function isDismissed(variantId) {
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + variantId) === "1";
  } catch {
    return false;
  }
}

function dismiss(variantId) {
  try {
    sessionStorage.setItem(STORAGE_PREFIX + variantId, "1");
  } catch {
    // privacy-modus zonder storage: het blok verdwijnt dan alleen voor deze render
  }
}

class ReserveDoppenComponent extends HTMLElement {
  static observedAttributes = ["hidden"];

  connectedCallback() {
    this.variantId = this.dataset.variantId || "";
    this.unitPrice = Number(this.dataset.unitPrice) || 0;
    this.min = Math.max(1, Number(this.dataset.min) || 1);
    this.step = Math.max(1, Number(this.dataset.step) || 1);

    if (isDismissed(this.variantId)) {
      this.hidden = true;
      return;
    }

    this.priceEl = this.querySelector(".reserve-doppen__price");
    this.qtyEl = this.querySelector(".reserve-doppen__qty");
    this.input = this.querySelector(".reserve-doppen__quantity");
    this.minusButton = this.querySelector(".reserve-doppen__stepper-button--minus");
    this.plusButton = this.querySelector(".reserve-doppen__stepper-button--plus");
    this.form = this.querySelector("form");

    if (this.bound) return; // morph hergebruikt het element: listeners staan er al
    this.bound = true;
    this.minusButton?.addEventListener("click", () => this.setQuantity(this.quantity - this.step));
    this.plusButton?.addEventListener("click", () => this.setQuantity(this.quantity + this.step));
    // Submit loopt via product-form-component (fetch + drawer-refresh); wij onthouden alleen
    // dat de bezoeker reserve-doppen heeft toegevoegd en halen het blok weg.
    this.form?.addEventListener("submit", () => {
      dismiss(this.variantId);
      window.setTimeout(() => {
        this.hidden = true;
      }, 1200);
    });
    this.render();
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    if (name === "hidden" && newValue === null && isDismissed(this.variantId)) {
      this.hidden = true;
    }
  }

  get quantity() {
    const value = Number(this.input?.value);
    return Number.isFinite(value) && value > 0 ? value : this.min;
  }

  setQuantity(value) {
    const quantity = Math.max(this.min, value);
    if (this.input) {
      this.input.value = String(quantity);
      this.input.setAttribute("value", String(quantity));
    }
    this.render();
  }

  render() {
    const quantity = this.quantity;
    if (this.qtyEl) this.qtyEl.textContent = String(quantity);
    if (this.priceEl) this.priceEl.textContent = `+ ${formatCurrency(quantity * this.unitPrice)}`;
    if (this.minusButton) this.minusButton.disabled = quantity <= this.min;
  }
}

if (!customElements.get("reserve-doppen-component")) {
  customElements.define("reserve-doppen-component", ReserveDoppenComponent);
}
